// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"0f1624be","70":"6404a6ad","71":"5fdcb351","195":"3a1635a6","213":"9821055e","216":"274c6dce","293":"7dbe9e27","349":"918f23cd","360":"debdbbdd","419":"0ffd5c17","606":"0387c07f","621":"4c9424fa","667":"672d16cc","832":"7c0a0f26","870":"3b1c2a9d"}[chunkId] + ".chunk.js";
};